import 'reflect-metadata';

import { container, Lifecycle } from 'tsyringe';

import { EpgStore, TimeWatcher, PlayoutStoreV2 } from '../category';
import { LastWatchedLinearStore } from '../channelStats/last-watched-linear-store';
import { DmsStore } from '../dms';
import { FavoriteRepository } from '../favoriteRepository/favorite-repository';
import { LinearRepository } from '../linearRepository/linear-repository';
import { LocalizationStore } from '../localization';
import { ParentalPinStore } from '../parentalPin/parental-pin-store';
import { ParentalPinStoreDepreciated } from '../parentalPin/parental-pin-store-depreciated';
import { ProvidersRepository } from '../providersRepository';
import { RecordRepository } from '../recordRepository';
import { SubscriptionsRepository } from '../subscriptionsRepository';
import { TransactionStore } from '../transaction/transaction-store';
import { DeviceStore } from '../user/device-store';
import { LoginStore } from '../user/login-store';
import { UserStore } from '../user/user-store';

import { AppParametersStore } from './app-params-store';

export function registerContainers() {
  container.register<LoginStore>('loginStore', { useClass: LoginStore }, { lifecycle: Lifecycle.Singleton });
  container.register<UserStore>('userStore', { useClass: UserStore }, { lifecycle: Lifecycle.Singleton });

  container.register<DeviceStore>('deviceStore', { useClass: DeviceStore }, { lifecycle: Lifecycle.Singleton });
  container.register(
    'appParamsStore',
    { useClass: AppParametersStore },
    { lifecycle: Lifecycle.Singleton }, // <- this is important
  );

  container.register<DmsStore>('dmsStore', { useClass: DmsStore }, { lifecycle: Lifecycle.Singleton });

  container.register<LocalizationStore>(
    'localizationStore',
    { useClass: LocalizationStore },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<ParentalPinStore>(
    'parentalPinStore',
    { useClass: ParentalPinStore },
    { lifecycle: Lifecycle.Singleton },
  );
  container.register<ParentalPinStoreDepreciated>(
    'parentalPinStoreDepreciated',
    { useClass: ParentalPinStoreDepreciated },
    { lifecycle: Lifecycle.Singleton },
  );
  container.register<TimeWatcher>('timeWatcher', { useClass: TimeWatcher }, { lifecycle: Lifecycle.Transient });
  container.register<EpgStore>('epgStore', { useClass: EpgStore });
  container.register<PlayoutStoreV2>('playoutStore', { useClass: PlayoutStoreV2 }, { lifecycle: Lifecycle.Singleton });
  container.register<TransactionStore>(
    'transactionStore',
    { useClass: TransactionStore },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<RecordRepository>(
    'recordRepository',
    { useClass: RecordRepository },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<LastWatchedLinearStore>(
    'lastWatchedLinearStore',
    { useClass: LastWatchedLinearStore },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<LinearRepository>(
    'linearRepository',
    { useClass: LinearRepository },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<SubscriptionsRepository>(
    'subscriptionsRepository',
    { useClass: SubscriptionsRepository },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<ProvidersRepository>(
    'providersRepository',
    { useClass: ProvidersRepository },
    { lifecycle: Lifecycle.Singleton },
  );

  container.register<FavoriteRepository>(
    'favoriteRepository',
    { useClass: FavoriteRepository },
    { lifecycle: Lifecycle.Singleton },
  );
}
